import { createSelector } from 'reselect';
import { beginTask, endTask } from 'redux-nprogress';

// ------------------------------------
// Selectors
// ------------------------------------
export const STORE_KEY = 'toolDescriptions';
export const selectToolDescriptionsState = state => state[STORE_KEY];

// ------------------------------------
// Reducer
// ------------------------------------
const actions = {};
const initialState = {
  toolDescriptions: {},
  toolsLoaded: false,
  hasLoaded: false,
  error: null,
};

const toolDescriptionsReducer = (state = initialState, action) => {
  const handler = actions[action.type];

  return handler ? handler(state, action) : state;
};

export default toolDescriptionsReducer;

// ------------------------------------
// Actions
// ------------------------------------
export const LOAD_TOOLDESCRIPTIONS_REQUEST = `${STORE_KEY}/LOAD_TOOLDESCRIPTIONS_REQUEST`;
export const LOAD_TOOLDESCRIPTIONS_SUCCESS = `${STORE_KEY}/LOAD_TOOLDESCRIPTIONS_SUCCESS`;
export const LOAD_TOOLDESCRIPTIONS_ERROR = `${STORE_KEY}/LOAD_TOOLDESCRIPTIONS_ERROR`;

export const loadToolDescriptionsRequest = () => ({
  type: LOAD_TOOLDESCRIPTIONS_REQUEST });
export const loadToolDescriptionsSuccess = (toolDescriptions) => ({
  type: LOAD_TOOLDESCRIPTIONS_SUCCESS,
  payload: { toolDescriptions },
});export const loadToolDescriptionsError = error => ({
  type: LOAD_TOOLDESCRIPTIONS_ERROR,
  payload: {
    error,
  },
});

actions[LOAD_TOOLDESCRIPTIONS_REQUEST] = (state, { payload }) => ({ ...state,
});
actions[LOAD_TOOLDESCRIPTIONS_SUCCESS] = (state, { payload: { toolDescriptions } }) => ({ ...state,
  toolDescriptions,
  toolsLoaded: true,
});
actions[LOAD_TOOLDESCRIPTIONS_ERROR] = (state, { payload }) => ({ ...state,
  error: payload.error,
});

export const loadToolDescriptions = () => async (dispatch, getState, { api }) => {
  try {
    dispatch(beginTask());
    dispatch(loadToolDescriptionsRequest());
    const toolDescriptions = await api.lookups.getToolDescriptions();
    dispatch(loadToolDescriptionsSuccess(toolDescriptions));
  } catch (error) {
    console.error(error);
    dispatch(loadToolDescriptionsError(error));
  } finally {
    dispatch(endTask());
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/toolDescriptions.js